import { MyContext } from "../MyProvider";
import React from "react";
let lang = 0;

// const x = () => (
//   <MyContext.Consumer>
//     {context => {
//       lang = context.state.language;
//       console.log(lang);
//       return <p>{context.state.language}</p>;
//     }}
//   </MyContext.Consumer>
// );

// console.log(x());
// x();

export const baseStyles = {
  // 0: direction, 1: textAlign
  getDirection: (lang, type) => {
    if (type === 0) return lang < 2 ? "rtl" : "ltr";
    if (type === 1) return lang < 2 ? "right" : "left";
  },

  horizontalValue: (lang, value) => {
    return lang < 2
      ? `auto auto auto ${value}px `
      : `auto ${value}px auto auto`;
  },

  horizontalValueOther: (lang, value) => {
    return lang >= 2
      ? `auto auto auto ${value}px `
      : `auto ${value}px auto auto`;
  },

  antBtn: {
    margin: "0px 8px"
  },

  adpPrimaryBtn: {},

  adpSecondaryBtn: {},

  headerMenu: {
    textAlign: "center",
    fontSize: "1.5em",
    padding: "16px 0 16px 0"
  },

  links: {
    listStyle: "none",
    textDecoration: "none"
  },

  list: {
    listStyle: "none"
  },

  baseTextHeader: {
    color: "#FF4081",
    fontSize: "1.8em",
    marginBottom: "0px"
  },

  baseTextHeaderWrapper: {
    // margin: '1.4em',
    // borderBottom: "1px solid #E0E0E0",
    paddingBottom: "1em"
  },

  baseTextHeaderWrapperMultiple: {
    margin: "1.4em"
  },

  baseTextInput: {
    width: "360px",
    maxWidth: "90%",
    margin: "0 40px",
    verticalAlign: "top"
  },

  baseAutocompleteInput: {
    width: "360px",
    margin: "0 60px 0 20px",
    verticalAlign: "top"
  },

  baseSelect: {
    width: "407px",
    maxWidth: "90%",
    marginTop: 16,
    margin: "16px 17px"
  },

  baseButton: {
    margin: "12px 40px 12px 40px ",
    height: 46,
    minWidth: 160
  },

  baseDatePicker: {
    width: "360px",
    maxWidth: "90%",
    margin: "0 40px",
    color: "#9e9e9e"
  },

  baseinputDivWrapper: {
    alignItems: "flex-end",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    marginBottom: "2em"
  },

  equalSign: {
    lineHeight: 6,
    fontWeight: "bold"
  },

  baseFloatingLabelFont: "1.3em",

  baseLightBorder: "1px solid #E0E0E0",
  baseLightBorderDotted: "1px dotted #E0E0E0",
  baseDarkBorder: "1px solid #BDBDBD",
  baseDarkerBorder: "1.4px solid #BDBDBD",
  baseDarkBorderDotted: "1px dashed #BDBDBD"
};

export const baseColors = {
  primary: "#1890FF",
  bgmBlue: "#00BCD4",
  bgmDarkBlue: "#00ACC1",
  bgmGreen: "#009688",
  bgmPink: "#FF4081",
  baseFloatingLabelColor: "#9E9E9E",
  baseUnderlineBorderColor: "#AFAFAF",
  bgGray: "#363636",
  bgOrange: "#F7941D",
  backgroundGrayDark: "#EEEEEE",
  bgYallow: "#ffcc2a",
};

export const boxShadow = {
  levelOne: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)"
};

export const baseToggleStyle = {
  block: {
    maxWidth: 250
  },
  toggle: {
    marginBottom: "2em",
    marginLeft: 16,
    width: "48%"
  },
  thumbOff: {
    backgroundColor: "#FFA4C1"
  },
  trackOff: {
    backgroundColor: "#FFD9E5"
  },
  thumbSwitched: {
    backgroundColor: baseColors.bgmPink
  },
  trackSwitched: {
    backgroundColor: "#FF9EBF"
  },
  labelStyle: {
    color: "red"
  }
};

export const unsafeButtonStyle = {
  submitBtn: {
    backgroundColor: baseColors.bgmBlue,
    border: "none",
    color: "white",
    margin: "10px 0 20px 0"
  },

  addBtn: {
    backgroundColor: baseColors.bgmBlue,
    border: "none",
    color: "white"
  },

  deleteBtn: {
    backgroundColor: baseColors.bgmPink,
    border: "none",
    color: "white"
  }
};

export const unsafeDivStyle = {
  flex: {
    display: "flex"
  }
};

export const adpInputStyle = {
  size: 300
}

// linearBlue: {
//     background: [
//       'linear-gradient(45deg, rgba(0,169,191,1) 0%, rgba(0,188,212,1) 100%)',
//       '-moz-linear-gradient(45deg, rgba(0,169,191,1) 0%, rgba(0,188,212,1) 100%)',
//       '-webkit-gradient(linear, left bottom, right top, color-stop(0%, rgba(0,169,191,1)), color-stop(100%, rgba(0,188,212,1)))',
//       '-webkit-linear-gradient(45deg, rgba(0,169,191,1) 0%, rgba(0,188,212,1) 100%)',
//       '-o-linear-gradient(45deg, rgba(0,169,191,1) 0%, rgba(0,188,212,1) 100%)',
//       '-ms-linear-gradient(45deg, rgba(0,169,191,1) 0%, rgba(0,188,212,1) 100%)'
//     ]
//   }
